/**
 * @file  News Releases组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext} from 'react';
import moment from 'moment';
import {useHistory} from 'react-router-dom';
import IconFont from '~/component/Iconfont';
import {BasicLayoutContext} from '~/layout/BasicLayout';
import './index.less';


function News({id, item: {publishTime, title}}) {
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    const history = useHistory();

    function handleClickMobile() {}

    function handleClick() {
        // 爬虫获取的新闻，参数用id
        history.push(`/news/detail/${id}?type=news`);
    }
    return (
        <div
            className="news-container"
            role="button"
            onClick={isMobile ? handleClickMobile : handleClick}
            tabIndex={0}
        >
            <div
                onClick={handleClick}
                role="button"
                tabIndex={0}
                className="news-title"
            >
                {title}
            </div>

            <div className={isMobile ? 'news-date-detail' : ''}>
                <div className="news-date">
                    {moment(publishTime).format('YYYY-MM-DD')}
                </div>

                {isMobile && (
                    <div
                        className="news-detail"
                        role="button"
                        onClick={handleClick}
                        tabIndex={0}
                    >
                        Details
                        <IconFont type="iconxiala" className="iconxiala" />
                    </div>
                )}

            </div>
        </div>
    );
}

export default News;
